import { request } from '../../../global/services/request'

export async function getAccount(accountId: string) {
  return await request({
    path: `/accounts/${accountId}?include=subscription,subscription.reseller`,
    method: 'get'
  })
}

